import { render, staticRenderFns } from "./ConversationTransfer.vue?vue&type=template&id=3568b600&"
import script from "./conversation-transfer.ts?vue&type=script&lang=ts&"
export * from "./conversation-transfer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports